import { Validate } from 'react-hook-form'

export const validateRoutingNumber: Validate = (routingNumber: string) => {
  const allNumericRegex = /^\d+$/
  if (!allNumericRegex.test(routingNumber)) {
    return 'All characters must be numeric'
  }

  if (routingNumber.length !== 9) {
    return 'Length must equal 9 digits'
  }

  // calculate checksum
  let sum = 0
  for (let i = 0; i < routingNumber.length; i += 3) {
    sum += parseInt(routingNumber.charAt(i)) * 3
    sum += parseInt(routingNumber.charAt(i + 1)) * 7
    sum += parseInt(routingNumber.charAt(i + 2))
  }

  // check if checksum is valid
  if (sum % 10 !== 0) {
    return 'Not a valid routing number'
  }

  // check if the first two digits are in the valid ranges
  const firstTwoDigits = parseInt(routingNumber.substring(0, 2))

  return (
    (firstTwoDigits >= 0 && firstTwoDigits <= 12) ||
    (firstTwoDigits >= 21 && firstTwoDigits <= 32) ||
    (firstTwoDigits >= 61 && firstTwoDigits <= 72) ||
    firstTwoDigits === 80 ||
    'Not a valid routing number'
  )
}

export const validateAccountNumber: Validate = (accountNumber: string) => {
  if (accountNumber.length > 17) {
    return 'Must not be longer than 17 characters'
  }

  const alphanumericRegex = /^[A-Za-z0-9-]+$/
  if (!alphanumericRegex.test(accountNumber)) {
    return 'All characters must be alphanumeric'
  }
  return undefined
}
